import { useEffect, useState } from "react";
import { loadMemberIntro } from "./load-member-intro";
import { MemberIntroProfile } from "./types";

const useMemberIntro = (
  lookupIds: Array<string | null | undefined>,
  refreshKey = 0
): { intro: MemberIntroProfile | null; isLoading: boolean } => {
  const ids = lookupIds.filter((id): id is string => !!id);
  const key = ids.join("|");
  const requestKey = `${key}#${refreshKey}`;
  const [intro, setIntro] = useState<MemberIntroProfile | null>(null);
  const [resolvedKey, setResolvedKey] = useState("");

  useEffect(() => {
    if (!ids.length) {
      setIntro(null);
      setResolvedKey(requestKey);
      return;
    }
    let cancelled = false;
    loadMemberIntro(ids).then(result => {
      if (!cancelled) {
        setIntro(result);
        setResolvedKey(requestKey);
      }
    });
    return () => {
      cancelled = true;
    };
    // ids is represented by requestKey; a fresh array each render must not refetch
  }, [requestKey]);

  const isLoading = key !== "" && resolvedKey !== requestKey;
  return { intro, isLoading };
};

export default useMemberIntro;
